
import {
initWxJSSDK,
getUnPickOrderList,
cancelOrders,
checkQrCodeUsed,
openDoor,
getOpenDoorStatus,
getTerminalDetail,
finishWorkOrder,
supportCancelOrders
} from "@/common/js/api.js";
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'


export default {
components: {
Scroller,
Tab,
TabItem,
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Icon,
Flexbox,
FlexboxItem,
Sticky,
Actionsheet
},
methods: {
scanQrCode(orderId) {
let self = this;
self.currentOrderId = orderId;




this.$wechat.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function(res) {



var result = res.resultStr; 
if (result.split(",").length > 1) {
result = result.split(",")[1];
}
if (result.indexOf("http") > -1) {
self.$vux.toast.text("请扫包裹条形码");
return;
}
checkQrCodeUsed({ data: { qrCode: result } }).then(function(data) {
if (data.Content == "F") {
self.$router.push({
path: "/support/orderScan",
query: {
orderId: self.currentOrderId,
qrCode: result,
sid: self.sid,
workOrderId: self.orderId
}
});
} else {
self.$vux.toast.text("条形码已使用！");
}
});
}
});
},
openDoor() {
let self = this;
this.$vux.confirm.show({

title: "提醒您",
content: "确定打开回收箱的所有门？",
onCancel() {},
onConfirm() {
self.times = 0;
self.$vux.loading.show({
text: "正在打开..."
});
openDoor({ data: { terminalId: self.sid } }).then(function(data) {
self.serialNumber = data.Content;
setTimeout(self.refreshSerialNumber, 3000);
});
}
});
},
refreshSerialNumber() {
let self = this;
self.times++;
if (self.times > 15) {
self.$vux.loading.hide();
self.$vux.toast.text("开门指令超时未响应！");
return;
}
getOpenDoorStatus({
data: {
terminalId: self.entity.terminalId,
serialNumber: self.serialNumber
}
}).then(
function(data) {
if (data.Message == "1") {
setTimeout(self.refreshSerialNumber, 2000);
} else {
self.$vux.loading.hide();
self.$vux.toast.text("门已打开");
}
},
function(data) {

}
);
},
getOrderList() {
let self = this;
getUnPickOrderList({ data: this.pageInfo }).then(function(data) {
self.view.firstLoad = false;
if (data.PageIndex > 1) {
self.list = self.list.concat(data.Content);
} else {
self.list = data.Content;
}
});
},
getTerminalDetail() {
let self = this;
getTerminalDetail({ data: { terminalId: self.sid } }).then(function(
data
) {
self.entity = data.Content;
});
},
finishWorkOrder() {
let self = this;
finishWorkOrder({ data: { orderId: self.orderId } }).then(function(data) {
self.$vux.toast.text("操作成功!");
setTimeout(function() {
history.go(-1);
}, 2000);
});
},
cancelOrder(id) {
let self = this;
self.showMenu = true;
self.currentId = id;
},
clickMenu(key) {
if (key == "cancel") {
return;
}
let self = this;
self.menuKey = key;
this.$vux.confirm.show({
title: "提醒您",
content: "确定取消该订单吗？",
onCancel() {},
onConfirm() {
supportCancelOrders({
data: {
orderId: self.currentId,
cancelType: self.menuKey,
workOrderId: self.orderId
}
}).then(function(data) {
self.$vux.toast.text("操作成功!");
self.getOrderList();
});
}
});
}
},
mounted() {
this.pageInfo.extInfo.sid = this.$route.query.sid;
this.sid = this.$route.query.sid;
this.orderId = this.$route.query.orderId;
this.getOrderList();
this.getTerminalDetail();
initWxJSSDK();
},
activated() {

console.log("activated");
},
data() {
return {
menuKey: null,
currentId: null,
showMenu: false,
menus: {
empty: "空箱",
waste: "废料"
},
view: {
loading: false,
firstLoad: true
},
status: {
pullupStatus: "default",
pulldownStatus: "default"
},
pullupConfig: {
content: "上拉加载更多",
downContent: "松开进行加载",
upContent: "上拉加载更多",
loadingContent: "加载中..."
},
pulldownConfig: {
content: "下拉刷新",
downContent: "下拉刷新",
upContent: "释放刷新",
loadingContent: "加载中..."
},
pageInfo: {
pageIndex: 1,
pageSize: 200,
keyword: "",
extInfo: { status: undefined }
},
title: "我的订单",
disabled:
typeof navigator !== "undefined" &&
/iphone/i.test(navigator.userAgent) &&
/ucbrowser/i.test(navigator.userAgent),
list: [],
times: 0,
sid: null,
serialNumber: null,
entity: { terminalId: "" },
orderId: null
};
}
};



// WEBPACK FOOTER //
// ./src/components/support/OrderList.vue